import { normalizeTransformable, Transformable } from '../utils/Transformable';
import type { LifecycleFns } from '../Def';
import type { AppPlugin } from '../Plugin';

declare module '../Def' {
    interface AppPluginOptionsWithGeneric<CustomProps> {
        lifecycle?: Transformable<LifecycleFns<CustomProps>>;
    }
}

export function createLifecycleBasePlugin<AdditionalOptions, CustomProps>(): AppPlugin<AdditionalOptions, CustomProps> {
    return ({ app, debug }) => {
        app.lifecycle.hooks.load.tapPromise('LifecycleBasePlugin', () => {
            debug('load');
            let loadingPromise: Promise<LifecycleFns<CustomProps> | void>;

            /* istanbul ignore else */
            if ('lifecycle' in app.options && app.options.lifecycle) {
                loadingPromise = normalizeTransformable(app.options.lifecycle);
            } else {
                loadingPromise = Promise.resolve();
            }
            return loadingPromise;
        });

        app.lifecycle.hooks.bootstrap.tapPromise('LifecycleBasePlugin', () => {
            debug('bootstrap');
            return app.lifecycle.fns.call('bootstrap', app.lifecycle.customProps, true).then(() => 'do it');
        });

        app.lifecycle.hooks.mount.tapPromise('LifecycleBasePlugin', () => {
            debug('mount');
            return app.lifecycle.fns.call('mount', app.lifecycle.customProps, false).then(() => 'do it');
        });

        app.lifecycle.hooks.unmount.tapPromise('LifecycleBasePlugin', () => {
            debug('unmount');
            return app.lifecycle.fns.call('unmount', app.lifecycle.customProps, false).then(() => 'do it');
        });

        app.lifecycle.hooks.update.tapPromise('LifecycleBasePlugin', ({ params }) => {
            debug('update');
            return app.lifecycle.fns
                .call(
                    'update',
                    {
                        ...app.lifecycle.customProps,
                        ...params,
                    },
                    false
                )
                .then(() => 'do it');
        });
    };
}
